import ImageKit from 'components/Image';

const StatisticsCard = ({ title, icon, infoKey, infoValue, data }) => {
	return (
		<div className="statistics-card">
			<header>{title}</header>
			<body>
				<div className="body-wrapper">
					<div className="icon">
						<ImageKit src={icon} width="100%" />
					</div>
					<div className="data">
						<p className="key">{infoKey}:</p>
						<p className="value">
							<strong>{data}</strong>
							{infoValue}
						</p>
					</div>
				</div>
			</body>
		</div>
	);
};
export default StatisticsCard;
